export default __webpack_public_path__ + "static/youtube-4b00ece2f31d41a64513d3219df4d2d6.png";